module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//10.jpg?d9617082c2ee1c41942f064357246f12";